import * as PopoverPrimitive from "@radix-ui/react-popover";

export const ComboboxRoot = PopoverPrimitive.Root;
